import { render, staticRenderFns } from "./PlantDataPoint.vue?vue&type=template&id=63ac83ec"
import script from "./PlantDataPoint.vue?vue&type=script&lang=js"
export * from "./PlantDataPoint.vue?vue&type=script&lang=js"
import style0 from "./PlantDataPoint.vue?vue&type=style&index=0&id=63ac83ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports